import { useTranslation } from 'react-i18next';

import { ModulePage } from '~/components/ModulePage/ModulePage';
import { useModulePageConfig } from '~/components/ModulePageConfigProvider';
import { ModulePageHeader } from '~/components/ModulePageHeader/ModulePageHeader';
import { ModuleSlot } from '~/components/ModuleSlot/ModuleSlot';
import { ModuleSlotId } from '~/modules';
import { RouteId } from '~/routes';

export const UserProfile = () => {
  const { t } = useTranslation(undefined, { keyPrefix: 'UserProfile' });
  const { modules } = useModulePageConfig({ pageId: RouteId.userProfile('') });

  return (
    <ModulePage
      header={<ModulePageHeader title={t('title')} />}
      modules={<ModuleSlot id={ModuleSlotId.MAIN} modules={modules} />}
    />
  );
};
